export default __webpack_public_path__ + "static/aBlock-10eca22923a21d57ec7554f004020ef3.svg";